import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AgendaPlannerResultComponent } from './agenda-planner-result/agenda-planner-result.component';
import { AgendaPlannerDesignComponent } from './agenda-planner-design/agenda-planner-design.component';
import { AgendaPlannerFormComponent } from './agenda-planner-form/agenda-planner-form.component';
import { DynamicAgendaPlannerComponent } from './dynamic-agenda-planner.component';
import { AgendaPlannerService } from './agenda-planner.service';
import { IonicModule } from '@ionic/angular';
import { MaterialModule } from 'src/app/shared/material.module';
import { KendoModule } from '../../kendo.module';
import { AbwConditionalFormatingModule } from '../../@core/abw-conditional-text-formating.module';
import { MDAgentPlannerAgentsPickerDialog } from "./agenda-planner-form/md-agent-planner-agents-picker-dialog/md-agent-planner-agents-picker-dialog.component";

@NgModule({
    declarations: [
        AgendaPlannerResultComponent,
        AgendaPlannerDesignComponent,
        AgendaPlannerFormComponent, DynamicAgendaPlannerComponent, 
        MDAgentPlannerAgentsPickerDialog
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        KendoModule,
        AbwConditionalFormatingModule,
    ],
    entryComponents: [
        DynamicAgendaPlannerComponent, 
        MDAgentPlannerAgentsPickerDialog
    ],
    providers: [
        AgendaPlannerService
    ]
})
export class AgendaPlannerModule {}